const PLP_BAR_WRAPPER_SELECTOR = '[id^="shopify-section-"].plp-cart-progressbar-parent';
const PLP_BAR_HEIGHT_PROPERTY = "--plp-bar-height";

let plpBarResizeObserver = null;
let plpBarLastHeight = null;
let plpBarStuckObserver = null;

function plpBarPublishHeight(wrapper) {
  if (!wrapper) return;
  const height = Math.round(wrapper.getBoundingClientRect().height);
  const next = `${height}px`;

  if (plpBarLastHeight === next) return;
  plpBarLastHeight = next;

  document.documentElement.style.setProperty(PLP_BAR_HEIGHT_PROPERTY, next);
}

function plpBarWatchStuck(wrapper) {
  plpBarStuckObserver?.disconnect();
  plpBarStuckObserver = null;

  if (!wrapper || !("IntersectionObserver" in window)) return;

  const stickyTop = parseFloat(getComputedStyle(wrapper).top) || 0;

  plpBarStuckObserver = new IntersectionObserver(
    ([entry]) => wrapper.classList.toggle("is-stuck", entry.intersectionRatio < 1),
    { rootMargin: `-${stickyTop + 1}px 0px 0px 0px`, threshold: [1] }
  );
  plpBarStuckObserver.observe(wrapper);
}

function plpBarObserve() {
  const wrapper = document.querySelector(PLP_BAR_WRAPPER_SELECTOR);

  plpBarResizeObserver?.disconnect();

  if (!wrapper) {
    document.documentElement.style.removeProperty(PLP_BAR_HEIGHT_PROPERTY);
    plpBarLastHeight = null;
    plpBarWatchStuck(null);
    return;
  }

  plpBarPublishHeight(wrapper);
  plpBarWatchStuck(wrapper);

  if (!("ResizeObserver" in window)) return;
  plpBarResizeObserver = new ResizeObserver(() => plpBarPublishHeight(wrapper));
  plpBarResizeObserver.observe(wrapper);
}

plpBarObserve();

document.addEventListener("shopify:section:load", plpBarObserve);
document.addEventListener("shopify:section:unload", plpBarObserve);

let plpBarResizeTimer = null;
window.addEventListener("resize", () => {
  clearTimeout(plpBarResizeTimer);
  plpBarResizeTimer = setTimeout(plpBarObserve, 150);
});
